import React from 'react'

import { Container, Avatar, Accessory } from './Avatar.styles'

const Component = ({ size, avatar, accessory, withProgressBar }) => {
  return (
    <Container size={size} withProgressBar={withProgressBar}>
      {/* {withProgressBar && <ProgressBar size={size} />} */}
      <Avatar size={size} src={avatar} />
      {accessory && <Accessory size={size} src={accessory} />}
    </Container>
  )
}

export default Component
